import { applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';

import { authReducer } from './redux/reducers/authReducer'
import { requestManagerReducer } from './redux/reducers/requestManagerReducer';
import { publicSysConfigReducer } from "./redux/reducers/publicConfigReducer";
import { confirmDialogReducer } from "./redux/reducers/confirmDialogReducer";
import { toastrReducer } from "./redux/reducers/toastrReducer";
import { fileBrowserReducer } from "./redux/reducers/fileBrowserReducer";
import { leftMenuReducer } from "./redux/reducers/leftMenuReducer";
import { userManagementReducer } from "./redux/reducers/userManagementReducer";
import { masterDataViewReducer } from "./redux/reducers/masterDataViewReducer";
import { masterDataReducer } from "./redux/reducers/masterDataReducer";
import { setModalBoxReducer } from "./redux/reducers/setModalBoxReducer";
import { ggRecaptchaReducer } from "./redux/reducers/recaptchaReducer";
import { setUploadResourceReducer } from "./redux/reducers/uploadResourceReducer";
import { jobManagementReducer } from "./redux/reducers/jobManagementReducer";
import { setUserReversedInfoReducer } from "./redux/reducers/userReversedInfoReducer";
import { adsManagementReducer } from "./redux/reducers/adsManagementReducer";
import storeManagementReducer from "./redux/reducers/storeManagementReducer";
import categoryManagementReducer from "./redux/reducers/categoryManagementReducer";
import storeSelectionReducer from "./redux/reducers/storeSelectionReducer";
import couponManagementReducer from "./redux/reducers/couponManagementReducer";
import productManagementReducer from "./redux/reducers/productManagementReducer";
import productProfileReducer from "./redux/reducers/productProfileReducer";
import serviceReducer from "./redux/reducers/serviceReducer";
import { orderManagementReducer } from './redux/reducers/orderManagementReducer';
import calculationFormulaManagementReducer from './redux/reducers/calculationFormulaReducer';
import { ordersManagementReducer } from './infrastructure/services/orders/redux/reducer';
import { prdManagementReducer } from './infrastructure/services/products/redux/reducer';
import { newCouponManagementReducer } from './infrastructure/services/coupons/redux/reducer';
import { dashboardManagementReducer } from './infrastructure/services/dashboard/redux/reducer';
import { reportManagementReducer } from './infrastructure/services/report/redux/reducer';


const appReducer = combineReducers({
    //For google recaptcha
    recaptcha: ggRecaptchaReducer,
    //For Authentication
    auth: authReducer,
    //For Request Manager
    request: requestManagerReducer,
    // For Public Sys Config
    publicSysConfig: publicSysConfigReducer,
    // For confirm dialog
    confirmDialog: confirmDialogReducer,
    // For modal box
    modalBox: setModalBoxReducer,
    // For toast message
    toastMessage: toastrReducer,
    // For file browser
    fileBrowser: fileBrowserReducer,
    // For left menu
    leftMenu: leftMenuReducer,
    // For resource uploading
    resourceUploader: setUploadResourceReducer,
    // For user reversed info
    userReversedInfo: setUserReversedInfoReducer,
    // FOR KEY MODULES
    // For user management module
    userManagement: userManagementReducer,
    // For master data view
    masterData: masterDataViewReducer,
    // For master data view
    masterManagement: masterDataReducer,
    // For job management module
    jobManagement: jobManagementReducer,
    // For advertisement module
    adsManagement: adsManagementReducer,
    // For store module
    storeManagement: storeManagementReducer,
    // For category module
    categoryManagement: categoryManagementReducer,
    // For store selection
    storeSelection: storeSelectionReducer,
    // For coupon module
    couponManagement: couponManagementReducer,
    // For product module
    productManagement: productManagementReducer,
    // For product-profile module
    productProfile: productProfileReducer,
    // For service management
    service: serviceReducer,
    // For order management
    orderManagement: orderManagementReducer,
    //get list calculation formula
    calculationFormulaManagement: calculationFormulaManagementReducer,

    //-------------------------- new store--------------------------------

    // quản lý đơn hàng
    newOrdersManagement: ordersManagementReducer,
    // quản lý sản phẩm
    newPrdManagement: prdManagementReducer,
    // quản lý mã giảm giá
    newCouponManagement: newCouponManagementReducer,
    // quản lý dashboard
    dashboardManagement: dashboardManagementReducer,
    // quản lý báo cáo
    reportManagement: reportManagementReducer,
});
const appStore = createStore(appReducer, applyMiddleware(thunk));
export default appStore;
